/* eslint-disable import/prefer-default-export */
import { View } from '@src/utils/graph.helpers'
import { IdentityTiles } from '@src/modules/identities/configurations/tiles.configurations'
import type { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type {
  PrivilegeTileInfo,
  ScopeTileInfo,
  RoleTileInfo,
  MemberTileInfo,
  InstanceTileInfo,
  IdentitySummaryInfo,
  UserTileInfo
} from '@src/endpoints/services/graphQueryMgr.service'
import type { InfoDetailsResult } from '@src/utils/resource.utils'
import type { SearchResult } from '../autocomplete.query'
import type { Graph } from '@src/components/vis.js.network.vis/models'

export type IdentityTotals = { [key in ResourceTypeEnum]?: number }

export interface IdentitySummaryItem extends IdentitySummaryInfo {
  account_name?: string
  scopes?: number
}

export interface ObjectItem extends SearchResult {}

export interface UserLocationItem {
  name?: string
  coordinates?: [number, number]
  radius?: number
}
export interface InfoDetails extends InfoDetailsResult {}

export interface IdentityTileUsedTotalValues {
  used: number
  total: number
}

// Reducer
export const defaultState = {
  objects: {
    used: 0,
    total: 0
  } as IdentityTileUsedTotalValues,
  countOfScopes: {
    used: 0,
    total: 0
  } as IdentityTileUsedTotalValues,
  countOfUTPrivileges: {
    used: 0,
    total: 0
  } as IdentityTileUsedTotalValues,
  countOfInstances: {
    used: 0,
    total: 0
  } as IdentityTileUsedTotalValues,
  countOfUsers: {
    used: 0,
    total: 0
  } as IdentityTileUsedTotalValues,
  countOfPrivileges: 0,
  membership: {
    roles: 0,
    rolesUsed: 0,
    groups: 0
  },
  selectedIdentityType: null as ResourceTypeEnum,
  totals: {} as IdentityTotals,
  countOfMembers: 0,
  overviewList: [] as IdentitySummaryItem[],
  graph: {} as Graph,
  infoDetails: {} as InfoDetails,
  userLocations: [] as UserLocationItem[],
  policyDocument: null as any,
  isPending: false,
  isPendingGraph: true,
  errors: null as any,
  displayName: null as string,
  displayScopeName: null as string,
  selectedGraphView: View.access,
  selectedTile: IdentityTiles.objects,
  selectedCounter: null as string,
  objectList: [] as ObjectItem[],
  priviligeList: [] as PrivilegeTileInfo[],
  scopeList: [] as ScopeTileInfo[],
  roleList: [] as RoleTileInfo[],
  memberList: [] as MemberTileInfo[],
  instanceList: [] as InstanceTileInfo[],
  userList: [] as UserTileInfo[]
}

export type IdentitiesState = typeof defaultState
